import { Platform } from '@/types/PlatformType';
import { Icon } from '@chakra-ui/react/icon';
import { HStack } from '@chakra-ui/react/stack';
import { IconType } from 'react-icons';
import { BsGlobe, BsNintendoSwitch } from 'react-icons/bs';
import { FaAndroid, FaApple, FaLinux, FaPlaystation, FaWindows, FaXbox } from 'react-icons/fa';
import { MdPhoneIphone } from 'react-icons/md';

interface Props {
	platforms: Platform[];
}

const PlatformIcons = ({ platforms }: Props) => {
	const iconMap: { [key: string]: IconType } = {
		pc: FaWindows,
		mac: FaApple,
		linux: FaLinux,
		xbox: FaXbox,
		playstation: FaPlaystation,
		nintendo: BsNintendoSwitch,
		android: FaAndroid,
		ios: MdPhoneIphone,
		web: BsGlobe
	};

	return (
		<HStack gap={'10px'} marginY={'12px'} color="fg.muted">
			{platforms.map((platform) => {
				const IconComponent = iconMap[platform.slug];
				if (!IconComponent) return null; // Skip rendering if no icon is found
				return (
					<Icon key={platform.id} size="lg" asChild>
						<IconComponent />
					</Icon>
				);
			})}
		</HStack>
	);
};

export default PlatformIcons;
